import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../scss/qr-size.scss';

import CustomRangeInput from '../../../../shared-components/custom-range-input/custom-range-input';

interface QRSizeProperties {
  qrValues: any;
  setQrValues: React.Dispatch<React.SetStateAction<any>>;
}

/**
 * QR Size Component
 * @param {QRSizeProperties} properties - Component properties
 * @param {any} properties.qrValues - The qrValues prop
 * @param {React.Dispatch<React.SetStateAction<any>>} properties.setQrValues - The setQrValues prop
 * @returns {JSX.Element} The QRSize component layout
 */
function QRSize({ qrValues, setQrValues }: QRSizeProperties): JSX.Element {
  const { t } = useTranslation('qrCode');

  const QrSizeProperties = [
    {
      id: 1,
      name: 'qrSize',
      value: qrValues.qrSize,
      label: t('qrSize'),
      min: 150,
      max: 200,
      valueType: 'Px',
    },
    {
      id: 2,
      name: 'qrMargin',
      value: qrValues.qrMargin,
      label: t('margin'),
      min: 10,
      max: 30,
      valueType: 'Px',
    },
  ];

  /**
   * Handling QR Size and Margin Range Values
   * @param {string} name - Property name
   * @param {string | number} value - Property value
   */
  const handleValue = (name: string, value: string | number) => {
    setQrValues((previous: any) => ({
      ...previous,
      [name]: value,
    }));
  };

  return (
    <div className="qr-size-wrap">
      <div className="qr-size">
        {QrSizeProperties.map((Property) => (
          <CustomRangeInput
            key={Property.id}
            label={Property.label}
            name={Property.name}
            value={Property.value}
            valueType={Property.valueType}
            onChange={handleValue}
            min={Property.min}
            max={Property.max}
          />
        ))}
      </div>
    </div>
  );
}

export default QRSize;
